import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  Table,
  CardFooter,
  UncontrolledTooltip,
  Progress,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import PayrollModel from "models/payroll.modal";
import TablePagination from "views/components/TablePagination";
import Loader from "components/loader/Loader";

const TutorPayRoll = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const parmas = useParams();
  const [status, setStatus] = useState("&class_status=All");
  const searchParams = new URLSearchParams(location.search);
  const [dueclass, setDueClass] = useState("");
  const [totalpage, setTotalpage] = useState();
  
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    try {
      let result;

      if (status && dueclass) {
        // Call API with three filters
        result = await PayrollModel.listfilter(
          status,
          dueclass,
        
          parameters
        );
      } else {
        result = await PayrollModel.list(status, parameters);
      }

      if (result) {
        console.log("API Response -> ", result);
        setDataList(result?.data);
        setTotalpage(result?.data?.meta?.total_page)
        setCurrentPage(result?.data?.meta?.current_page);
        setPerPage(result?.data?.meta?.per_page);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getListData();
  }, []);
  useEffect(() => {
    getListData();
  }, [currentPage]);
  useEffect(() => {
    getListData();
  }, [status,dueclass]);
  const [alldata, setAlldata] = useState();
  const [holddata, setHolddata] = useState();
  const [activedata, setAvtivedata] = useState();
  const [completeddata, setCompleteddata] = useState();
  const [discontinuddata, setDiscontinueddata] = useState();
  const [smedata, setSmedata] = useState();
  const [combineddata, setcombineddata] = useState();
  const [sepratedata, setSepratedata] = useState();

  const getListDatacount = async () => {
    await PayrollModel.list("&class_status=All")
      .then((result) => {
        if (result) {
          setAlldata(result?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
    await PayrollModel.list("&class_status=Active")
      .then((result) => {
        if (result) {
          setAvtivedata(result?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
    await PayrollModel.list("&class_status=Hold")
      .then((result) => {
        if (result) {
          setHolddata(result?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
    await PayrollModel.list("&class_status=Completed")
      .then((result) => {
        if (result) {
          setCompleteddata(result?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
    await PayrollModel.list("&class_status=Discontinued")
      .then((result) => {
        if (result) {
          setDiscontinueddata(result?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
    await PayrollModel.list("&class_type=SME")
      .then((result) => {
        if (result) {
          setSmedata(result?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
    await PayrollModel.list("&class_type=COMBINED")
      .then((result) => {
        if (result) {
          setcombineddata(result?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
    await PayrollModel.list("&class_type=SEPARATE")
      .then((result) => {
        if (result) {
          setSepratedata(result?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getListDatacount();
  }, []);

  console.log("task done",dataList)
  return (
    <div className="pt-7 px-4">
      <Row>
        <div className="col">
          <Card className="shadow">
            <Container style={{ marginTop: "20px" }}>
              <Row
                className="mb-1"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Col
                  md={7}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    justifyContent: "space-between",
                    border: "1px solid black",
                  }}
                >
                  <div
                    className={`${
                      status == "&class_status=All"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatus("&class_status=All");
                    }}
                  >
                    <span>All</span>{" "}
                    <span className="badge bg-secondary d-flex">
                      (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "&class_status=All" ? "black" : "blue",
                        }}
                      >
                        {" "}
                        {alldata?.length}{" "}
                      </span>
                      )
                    </span>
                  </div>
                  <div
                    className={`${
                      status == "&class_status=Hold"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatus("&class_status=Hold");
                    }}
                  >
                    <span>Hold</span>{" "}
                    <span className="badge bg-secondary  d-flex">
                      (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "&class_status=Hold" ? "black" : "blue",
                        }}
                      >
                        {holddata?.length}
                      </span>
                      )
                    </span>
                  </div>
                  <div
                    className={`${
                      status == "&class_status=Active"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatus("&class_status=Active");
                    }}
                  >
                    <span>Active</span>{" "}
                    <span className="badge bg-secondary  d-flex">
                      (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "&class_status=Active" ? "black" : "blue",
                        }}
                      >
                        {activedata?.length}
                      </span>
                      )
                    </span>
                  </div>
                  <div
                    className={`${
                      status == "&class_status=Completed"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatus("&class_status=Completed");
                    }}
                  >
                    <span>Completed</span>{" "}
                    <span className="badge bg-secondary ms-1 d-flex">
                      (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "&class_status=Completed"
                              ? "black"
                              : "blue",
                        }}
                      >
                        {completeddata?.length}
                      </span>
                      )
                    </span>
                  </div>
                  <div
                    className={`${
                      status == "&class_status=Discontinued"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatus("&class_status=Discontinued");
                    }}
                  >
                    <span>Discontinued</span>{" "}
                    <span className="badge bg-secondary ms-1 d-flex">
                      (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "&class_status=Discontinued"
                              ? "black"
                              : "blue",
                        }}
                      >
                        {discontinuddata?.length}
                      </span>
                      )
                    </span>
                  </div>
                </Col>
                <Col md={1}></Col>
                <Col
                  md={4}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    justifyContent: "space-between",
                    border: "1px solid black",
                  }}
                >
                  <div
                    className={`${
                      status == "&class_type=SME" ? "text-primary" : "text-dark"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatus("&class_type=SME");
                    }}
                  >
                    <span>SME</span>{" "}
                    <span className="badge bg-secondary ms-1 d-flex">
                      (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color: status == "&class_type=SME" ? "black" : "blue",
                        }}
                      >
                        {smedata?.length}
                      </span>
                      )
                    </span>
                  </div>
                  <div
                    className={`${
                      status == "&class_type=COMBINED"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatus("&class_type=COMBINED");
                    }}
                  >
                    <span>Combined</span>{" "}
                    <span className="badge bg-secondary ms-1 d-flex">
                      (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "&class_type=COMBINED" ? "black" : "blue",
                        }}
                      >
                        {combineddata?.length}
                      </span>
                      )
                    </span>
                  </div>
                  <div
                    className={`${
                      status == "&class_type=SEPARATE"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatus("&class_type=SEPARATE");
                    }}
                  >
                    <span>Separate</span>{" "}
                    <span className="badge bg-secondary ms-1 d-flex">
                      (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "&class_type=SEPARATE" ? "black" : "blue",
                        }}
                      >
                        {sepratedata?.length}
                      </span>
                      )
                    </span>
                  </div>
                </Col>
              </Row>
            </Container>
            <CardHeader className="border-0 d-flex justify-content-between ">
              <h3 className="mb-0">Tutor Payroll</h3>
              <div className="d-flex">
                <div className="mr-4">
                  <span className="mr-1">Due Classes</span>
                  <input
                    type="checkbox"
                    value="&getDueClasses=true"
                    onChange={(e) => {
                      setDueClass(e.target.checked ? e.target.value : "");
                    }}
                  />
                </div>
              </div>
            </CardHeader>

            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">SN.</th>
                  <th scope="col">Tutors </th>
                  <th scope="col">Student</th>
                  <th scope="col">Payroll Status</th>
                  <th scope="col">Class Name</th>
                  {/*<th scope="col">Salary made so far</th>*/}
                  <th scope="col">Status</th>
                  <th scope="col">Mode</th>
                  <th scope="col">Last Payment</th>

                  <th scope="col">Action</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={9} className="text-center align-middle py-4">
                      Please wait...
                      <Loader />
                    </td>
                  </tr>
                ) : dataList?.length > 0 ? 
                (
                  dataList.map((item, index) => {
                    const percentage = item?.price_tutor
                      ? ((item?.price_tutor - (item?.total_paid || 0)) /
                          item?.price_tutor) *
                        100
                      : 0;

                    return (
                      <tr key={index}>
                        {/* Serial Number */}
                        <td>{index + 1}</td>

                        {/* Tutor Name */}
                        <td>{`${item?.tutorData?.first_name} ${item?.tutorData?.last_name}`}</td>

                        {/* Student and Client Details */}
                        <td>
                          <div>
                            <div>
                              {item?.studentData?.map((student, idx) => (
                                <span
                                  key={idx}
                                  style={{
                                    fontSize: "14px",
                                    color: "skyblue",
                                  }}
                                >
                                  {student.name}
                                  {idx < item.studentData.length - 1 && ", "}
                                </span>
                              ))}
                            </div>
                            <div>
                              <span>Client- </span>
                              <span
                                style={{ fontSize: "14px", color: "skyblue" }}
                              >
                                {`${item?.parentData?.first_name} ${item?.parentData?.last_name}`}
                              </span>
                            </div>
                          </div>
                        </td>

                        {/* Progress Bar */}
                        <td>
                          <Progress
                            className="my-2"
                            value={percentage}
                            style={{ height: "25px" }}
                          >
                            {`${Math.round(percentage)}%`}
                          </Progress>
                        </td>

                        {/* Other Details */}
                        <td>{item?.name}</td>
                        <td>{item?.status}</td>
                        <td>{item?.mode}</td>
                        <td>{item?.lastPayment}</td>

                        {/* Action (View Link) */}
                        <td>
                          <UncontrolledTooltip
                            placement="top"
                            target={`eyeTooltip-${item._id}`}
                          >
                            View
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              marginTop: "10px",
                              display: "inline-block",
                              borderRadius: "30%",
                            }}
                            id={`eyeTooltip-${item._id}`}
                            to={`/admin/tutorpayroll/view/${item?.id}/${item?.lastClassCycle?.id}`}
                          >
                            <i className="fa-solid fa-eye"></i>
                          </Link>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={9} className="text-center align-middle ">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              {
                <TablePagination
                totalPages={totalpage}
                currentPage={currentPage}
                  pageUrl="/admin/tutorpayroll?"
                />
              }
            </CardFooter>
          </Card>
        </div>
      </Row>
    </div>
  );
};

export default TutorPayRoll;
